import React from "react";
import Link from 'gatsby-link'
import SvgBtnPersonnage2 from '../../images/bouton-personnage-2.svg'

export default () => (
  <Link to="/henriette-belley/" className="etiquette">
    <SvgBtnPersonnage2/>
    <span>Henriette Belley</span>
  </Link>
);



// WEBPACK FOOTER //
// ./src/components/btn-henriette-belley.js